import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { env } from '../environment';
import { RootState } from '../store';
import { Wishlist } from '../interfaces';

export const WishlistAPI = createApi({
  reducerPath: 'wishlistAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: env.apiUrl + '/wishlist',
    prepareHeaders: (headers, { getState }) => {
      const { accessToken } = (getState() as RootState).auth;
      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`);
      }
      return headers;
    }
  }),
  tagTypes: ['Wishlist'],
  endpoints: (build) => ({
    fetchWishlist: build.query<Wishlist[], void>({
      query: () => '/',
      providesTags: result => result
        ? [...result.map(({ id }) => ({ type: 'Wishlist' as const, id }))]
        : ['Wishlist'],
    }),
    createWishlist: build.mutation<Wishlist, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['Wishlist'],
    }),
    deleteWishlist: build.mutation<Wishlist, string>({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) =>
        result ? [{ type: 'Wishlist', id }] : ['Wishlist'],
    }),
  }),
});

export const {
  useFetchWishlistQuery,
  useCreateWishlistMutation,
  useDeleteWishlistMutation,
} = WishlistAPI;